'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickCloseButton", "children", "content"];
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import { useDismissStep } from '../hooks/tourHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const BlogNewFeaturesTourStep = _ref => {
  let {
      onClickCloseButton,
      children,
      content
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const dismissStep = useDismissStep();
  return /*#__PURE__*/_jsx(UITourStep, Object.assign({
    width: 350,
    placement: "bottom",
    showCloseButton: true,
    closeOnOutsideClick: false,
    autoPlacement: false,
    content: {
      header: content.header,
      body: content.body,
      footer: content.footer
    },
    onClickCloseButton: stepKey => {
      dismissStep(stepKey);
      if (typeof onClickCloseButton === 'function') {
        onClickCloseButton(stepKey);
      }
    }
  }, rest, {
    children: children
  }));
};